import { Skeleton } from "@heroui/react";

import {
  OrganizationLogo,
  OrganizationLogoProps,
} from "@/components/organization/OrganizationLogo";
import { useCurrentOrganizationContext } from "@/contexts";

export type CurrentOrganizationLogoProps = Omit<OrganizationLogoProps, "organization">;

export const CurrentOrganizationLogo = ({
  width,
  height,
  ...props
}: CurrentOrganizationLogoProps) => {
  const { organization: currentOrganization, loading: currentOrganizationLoading } =
    useCurrentOrganizationContext();

  return currentOrganizationLoading ? (
    <Skeleton style={{ height, width }} className="rounded-medium" />
  ) : currentOrganization ? (
    <OrganizationLogo organization={currentOrganization} height={height} width={width} {...props} />
  ) : null;
};
